<template>
    <div class="bidder-child-page">
        <div class="page-header">
            <div class="page-header-content">
                <h2 class="page-title">{{projectTitle}}</h2>
                <h2 class="page-title">响应文件</h2>
            </div>
            <div class="header-action">
                <el-button type="primary" icon="el-icon-arrow-left" @click="handleBack">返回项目流程界面</el-button>
            </div>
        </div>
        <!-- 内容区 -->
        <div class="content-container">
            <!-- 公司信息卡片 -->
            <div class="info-card">
                <div class="card-header">
                    <i class="el-icon-office-building"></i>
                    <h3 class="card-title">公司信息</h3>
                </div>
                <div class="card-body">
                    <el-row :gutter="20">
                        <el-col :span="24">
                            <div class="info-item-row">
                                <label class="info-label">投标人名称</label>
                                <div class="info-value">{{ companyInfo.userName || '-' }}</div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </div>

            <!-- 上传投标文件卡片 -->
            <!-- <div class="info-card">
                <div class="card-header">
                    <i class="el-icon-upload"></i>
                    <h3 class="card-title">上传投标文件</h3>
                </div>
                <div class="card-body">
                    <div class="upload-container">
                        <div class="upload-box" :class="{ 'uploaded': infoData.isOnline == 1 }">
                            <div class="upload-icon">
                                <i :class="infoData.isOnline == 1 ? 'el-icon-success' : 'el-icon-upload'"></i>
                            </div>
                            <div class="upload-text">
                                <p class="upload-title">{{ infoData.isOnline == 1 ? '文件已上传' : '点击上传投标文件' }}</p>
                                <p class="upload-hint">支持 PDF、Word、图片等格式，单个文件不超过 10GB</p>
                            </div>
                            <el-button type="primary" size="medium" :disabled="infoData.isOnline == 1"
                                @click="handleUploadBidDocument" class="upload-btn">
                                <i class="el-icon-upload2"></i>
                                {{ infoData.isOnline == 1 ? '已上传' : '选择文件' }}
                            </el-button>
                        </div>
                    </div>
                </div>
            </div> -->

            <!-- 投标信息卡片 -->
            <div class="info-card" v-if="uploadedBidFile.fileId !== ''">
                <div class="card-header">
                    <i class="el-icon-document-checked"></i>
                    <h3 class="card-title">投标信息</h3>
                    <!-- <el-tag :type="statusButtonType" size="medium" class="status-tag">
                        <i :class="statusButtonType === 'success' ? 'el-icon-circle-check' : 'el-icon-warning'"></i>
                        {{ displayFileStatus }}
                    </el-tag> -->
                </div>
                <div class="card-body">
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <div class="info-item-row">
                                <label class="info-label">投标文件</label>
                                <div class="info-value file-name">
                                    <i class="el-icon-document"></i>
                                    {{ uploadedBidFile.fileName || '-' }}
                                </div>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="info-item-row">
                                <label class="info-label">递交截止时间</label>
                                <div class="info-value">
                                    <i class="el-icon-time"></i>
                                    {{ uploadedBidFile.deadline || '-' }}
                                </div>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="info-item-row">
                                <label class="info-label">当前时间</label>
                                <div class="info-value">
                                    <i class="el-icon-time"></i>
                                    {{ uploadedBidFile.currentTime || '-' }}
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20" class="info-row spacing-top">
                        <el-col :span="12">
                            <div class="info-item-row">
                                <label class="info-label">投标文件编号</label>
                                <div class="info-value code">
                                    <i class="el-icon-tickets"></i>
                                    {{ uploadedBidFile.fileId }}
                                </div>
                            </div>
                        </el-col>
                        <!-- <el-col :span="12">
                            <div class="info-item-row">
                                <label class="info-label">CA锁名称</label>
                                <div class="info-value">
                                    <i class="el-icon-key"></i>
                                   ****979996
                                </div>
                            </div>
                        </el-col> -->
                    </el-row>
                    <!-- <div class="ca-notice">
                        <i class="el-icon-info"></i>
                        <span>请开标时使用此CA锁进行投标文件的解密操作，如需查看CA锁名称，可以打开CA数字证书助手点击"我的证书"进行查看</span>
                    </div> -->
                </div>
            </div>

            <!-- 项目负责人信息卡片 -->
            <div class="info-card">
                <div class="card-header">
                    <i class="el-icon-user"></i>
                    <h3 class="card-title">项目负责人信息</h3>
                </div>
                <div class="card-body">
                    <div class="info-notice">
                        <i class="el-icon-info"></i>
                        <span>请填写项目负责人相关信息，标记 * 的为必填项</span>
                    </div>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <div class="form-field">
                                <label class="field-label required">项目负责人姓名</label>
                                <el-input v-model="projectManager.name" placeholder="请输入姓名" prefix-icon="el-icon-user"
                                    clearable>
                                </el-input>
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div class="form-field">
                                <label class="field-label required">项目负责人手机号</label>
                                <el-input v-model="projectManager.phone" placeholder="请输入手机号"
                                    prefix-icon="el-icon-phone" clearable>
                                </el-input>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </div>
            <!-- 操作按钮 -->
            <div class="action-footer">
                <el-button type="primary" size="large" icon="el-icon-upload2" @click="uploadBidDocument"
                    v-if="infoData.fileStatus == '未提交'">
                    提交投标文件
                </el-button>
                <el-button type="warning" size="large" icon="el-icon-refresh-left" @click="handleWithdraw" v-else>
                    撤回投标
                </el-button>
                <el-button type="success" size="large" icon="el-icon-document" @click="handleViewReceipt"
                    v-if="infoData.fileStatus != '未提交'">
                    查看回执
                </el-button>
                <el-button type="success" size="large" icon="el-icon-document" @click="uploadBidDocument"
                    v-if="infoData.fileStatus != '未提交'">
                    提交
                </el-button>
            </div>
        </div>

        <!-- 文件上传进度对话框 -->
        <el-dialog title="文件上传" :visible.sync="uploadProgress.visible" width="400px" :close-on-click-modal="false"
            :close-on-press-escape="false" :append-to-body="true" :show-close="false">
            <div class="upload-progress-content">
                <div class="upload-info">
                    <i class="el-icon-upload upload-icon"></i>
                    <span>{{ uploadProgress.fileName }}</span>
                </div>
                <el-progress :percentage="uploadProgress.percentage"
                    :status="uploadProgress.status === 'success' ? 'success' : (uploadProgress.status === 'error' ? 'exception' : null)"
                    class="upload-progress-bar">
                </el-progress>
                <div class="upload-status">
                    <span v-if="uploadProgress.status === 'uploading'">正在上传...</span>
                    <span v-else-if="uploadProgress.status === 'success'" class="status-success">上传成功</span>
                    <span v-else-if="uploadProgress.status === 'error'" class="status-error">上传失败</span>
                </div>
            </div>
        </el-dialog>

    </div>
</template>

<script>
import { getUploadDocumentDetail, uploadBidDocument, updateBidDocument, downloadReceiptPdf, revokeBidDocument } from '@/api/tenderNotice/api'
import { doFileUpload } from '@/utils/fileUploadHelper'
import { UPLOAD_CONSTANTS, timeUtils } from '@/utils/base'
import { getBidderFlowTitle } from '@/utils/projectInfo.js'
const CONSTANTS = {
    ...UPLOAD_CONSTANTS
}

export default {
    name: 'BidDocument',
    data() {
        return {
            infoData: {},
            sectionCode: this.$route.query.sectionCode || '',
            uploadFileId: '',
            projectInfo: {
                projectNumber: this.$route.query.projectNumber || '',
                projectName: this.$route.query.projectName || '',
                bidSectionCode: '',
                bidSectionName: ''
            },
            // 公司信息数据
            companyInfo: {
                userName: '',
                relationUser: '',
                userTel: '',
                postalCode: '',
                address: '',
                invoiceName: '',
                userPhone: '',
                billingCompany: ''
            },
            responseConditions: '',

            // 上传的投标文件信息
            uploadedBidFile: {
                fileName: '',
                fileId: '',
                uploadTime: '',
                deadline: '',
                currentTime: '',
                fileStatus: ''
            },

            // 文件上传进度
            uploadProgress: {
                visible: false,
                percentage: 0,
                fileName: '',
                status: null
            },

            // 文件绑定ID
            fileBindId: Date.now().toString(),

            // 项目负责人信息
            projectManager: {
                idNumber: '',
                name: '',
                title: '',
                certificateName: '',
                phone: '',
                certificateNumber: ''
            }
        }
    },
    computed: {
    },
    mounted() {
        this.getUploadDocumentDetail()
           this.getProjectInfo()
    },
    methods: {
         // 获取项目信息
        async getProjectInfo() {
            this.projectTitle = await getBidderFlowTitle(this.sectionCode);
        },

        // 获取投标文件上传详情
        getUploadDocumentDetail() {
            getUploadDocumentDetail({
                sectionCode: this.sectionCode
            }).then(res => {
                if (res && res.data) {
                    const data = res.data
                    this.infoData = data;
                    // 更新项目信息
                    if (data.projectCode) {
                        this.projectInfo.projectNumber = data.projectCode
                    }
                    if (data.projectName) {
                        this.projectInfo.projectName = data.projectName
                    }
                    if (data.sectionCode) {
                        this.projectInfo.bidSectionCode = data.sectionCode
                    }
                    if (data.sectionName) {
                        this.projectInfo.bidSectionName = data.sectionName
                    }
                    // 更新公司信息 - 投标人名称
                    if (data.bidderName) {
                        this.companyInfo.userName = data.bidderName
                    }
                    // 更新投标文件信息
                    if (data.fileId !== null && data.fileId !== undefined) {
                        this.uploadedBidFile.fileId = data.fileId
                    }
                    if (data.fileName !== null && data.fileName !== undefined) {
                        this.uploadedBidFile.fileName = data.fileName
                    }
                    if (data.deadline !== null && data.deadline !== undefined) {
                        this.uploadedBidFile.deadline = data.deadline
                    }
                    // 更新文件状态
                    if (data.fileStatus) {
                        this.uploadedBidFile.fileStatus = data.fileStatus
                    }
                    // 更新当前时间（如果有截止时间，可以使用截止时间，否则使用当前时间）
                    if (data.deadline) {
                        this.uploadedBidFile.currentTime = timeUtils.getCurrentTime()
                    }
                    // 更新项目负责人信息
                    if (data.projectManagerInfo) {
                        const pmInfo = data.projectManagerInfo
                        if (pmInfo.pmName) {
                            this.projectManager.name = pmInfo.pmName
                        }
                        if (pmInfo.pmPhone) {
                            this.projectManager.phone = pmInfo.pmPhone
                        }
                    }
                }
            }
            ).catch(error => {
                console.log(error)
                this.$message.error('获取文件信息失败')
            })
        },
        // 上传投标文件
        uploadBidDocument() {
            if (this.infoData.isOnline == 0) {
                const fileId = this.uploadFileId
                // 验证必填项
                if (!fileId) {
                    this.$message.warning('请先上传文件')
                    return
                }
            }
            if (!this.projectManager.name) {
                this.$message.warning('请填写项目负责人姓名')
                return
            }
            if (!this.projectManager.phone) {
                this.$message.warning('请填写项目负责人手机号')
                return
            }
            const params = {
                sectionCode: this.sectionCode || '',
                pmName: this.projectManager.name || '',
                pmPhone: this.projectManager.phone || '',
                uploadFileId: this.uploadFileId
            }
            if (this.infoData.isOnline == 0) {
                params.uploadFileId = fileId || '',
                    uploadBidDocument(params).then(res => {
                        if (res && res.code === 200) {
                            this.$message.success('提交成功')
                            this.getUploadDocumentDetail()
                        } else {
                            this.$message.error(res?.message || '提交失败')
                        }
                    }).catch(error => {
                        console.error(error)
                        this.$message.error('提交失败')
                    })
            } else {
                updateBidDocument(params).then(res => {
                    if (res && res.code === 200) {
                        this.$message.success('提交成功')
                        this.getUploadDocumentDetail()
                    } else {
                        this.$message.error(res?.message || '提交失败')
                    }
                }).catch(error => {
                    console.error(error)
                    this.$message.error('提交失败')
                })
            }

        },
        // 返回上一页
        handleBack() {
            this.$router.go(-1)
        },

        // 撤回
        handleWithdraw() {
            this.revokeBidDocument()
        },
        //撤销文件
        async revokeBidDocument() {
            const res = await revokeBidDocument({
                sectionCode: this.sectionCode
            })
            if (res.code == 200) {
                this.$message.success('撤销成功')
                setTimeout(() => {
                    this.handleBack()
                }, 1000);

            } else {
                this.$message.success(res.msg)
            }


        },



        // 查看回执 - 直接下载文件流
        async handleViewReceipt() {
            try {
                this.$message.info('正在下载回执文件...')

                const res = await downloadReceiptPdf({
                    sectionCode: this.sectionCode
                })

                // 处理文件流下载
                if (res) {
                    // 创建blob对象
                    const blob = new Blob([res], {
                        type: 'application/pdf'
                    })

                    // 创建下载链接
                    const url = window.URL.createObjectURL(blob)
                    const link = document.createElement('a')
                    link.href = url
                    link.download = `投标文件回执_${this.sectionCode}_${new Date().getTime()}.pdf`
                    // 触发下载
                    document.body.appendChild(link)
                    link.click()

                    // 清理
                    document.body.removeChild(link)
                    window.URL.revokeObjectURL(url)

                    this.$message.success('回执文件下载成功')
                } else {
                    this.$message.error('回执文件下载失败')
                }
            } catch (error) {
                console.error('下载回执文件错误:', error)
                this.$message.error('下载回执文件失败')
            }
        },

        // 上传投标文件
        handleUploadBidDocument() {
            const input = document.createElement('input')
            input.type = 'file'
            input.accept = CONSTANTS.SUPPORTED_FILE_TYPES
            input.onchange = (e) => {
                this.handleBidFileSelect(e)
            }
            input.click()
        },

        // 处理投标文件选择
        async handleBidFileSelect(event) {
            const file = event.target.files[0]
            if (!file || !this.validateFile(file)) return

            try {
                this.showUploadProgress(file)
                const uploadResult = await this.uploadFileWithChunks(file)
                this.uploadFileId = uploadResult.fileId
                this.handleBidUploadResult(uploadResult, file)
            } catch (error) {
                this.handleUploadError(error, file)
            }
        },

        // 验证文件
        validateFile(file) {
            const maxSize = 102400 * 1024 * 1024 // 10GB
            if (file.size > maxSize) {
                this.$message.error('文件大小不能超过10GB')
                return false
            }
            const allowedTypes = CONSTANTS.SUPPORTED_FILE_TYPES.split(',')
            const fileExtension = '.' + file.name.split('.').pop().toLowerCase()
            if (!allowedTypes.includes(fileExtension)) {
                this.$message.error('不支持的文件类型')
                return false
            }
            return true
        },

        // 显示上传进度
        showUploadProgress(file) {
            this.uploadProgress = {
                visible: true,
                percentage: 0,
                fileName: file.name,
                status: CONSTANTS.STATUS.UPLOADING
            }
        },

        // 上传文件
        async uploadFileWithChunks(file) {
            let uploadedFileId = null
            const uploadResult = await doFileUpload(file, {
                fileBindId: this.fileBindId,
                onProgress: (progress) => {
                    this.uploadProgress.percentage = Math.round(Number(progress) || 0)
                },
                onSuccess: (r) => {
                    uploadedFileId = r.fileId
                },
                onError: () => { }
            })
            if (uploadResult && uploadedFileId) {
                uploadResult.fileId = uploadedFileId
            }
            return uploadResult
        },

        // 处理投标文件上传结果
        handleBidUploadResult(uploadResult, file) {
            if (uploadResult && uploadResult.success) {
                this.uploadProgress.status = CONSTANTS.STATUS.SUCCESS
                this.uploadProgress.percentage = 100

                // 获取当前时间
                const currentTime = timeUtils.getCurrentTime()

                // 更新上传的投标文件信息
                // 如果当前状态是"未提交"，保持原状态，让计算属性显示"已上传"
                // 否则更新为"已提交"
                const currentStatus = this.uploadedBidFile.fileStatus
                const newStatus = (currentStatus === '未提交' || currentStatus === 'NOT_SUBMITTED')
                    ? currentStatus
                    : '已提交'

                this.uploadedBidFile = {
                    fileName: file.name,
                    fileId: uploadResult.fileId || uploadResult.id || '',
                    uploadTime: currentTime,
                    deadline: currentTime,
                    currentTime: currentTime,
                    fileStatus: newStatus
                }

                setTimeout(() => {
                    this.uploadProgress.visible = false
                    this.$message.success(`文件 ${file.name} 上传成功`)
                }, 1000)
            } else {
                this.uploadProgress.status = CONSTANTS.STATUS.ERROR
                setTimeout(() => {
                    this.uploadProgress.visible = false
                    this.$message.error(`文件上传失败: ${uploadResult?.message || '未知错误'}`)
                }, 1000)
            }
        },

        // 处理上传错误
        handleUploadError(error, file) {
            this.uploadProgress.status = CONSTANTS.STATUS.ERROR
            setTimeout(() => {
                this.uploadProgress.visible = false
                this.$message.error(`文件上传失败: ${error.message || '未知错误'}`)
            }, 1000)
        },

        // 删除投标文件
        handleDeleteBidFile() {
            this.$confirm('确定要删除这个文件吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.uploadedBidFile = {
                    fileName: '',
                    fileId: '',
                    uploadTime: '',
                    deadline: '',
                    currentTime: '',
                    fileStatus: ''
                }
                this.$message.success('删除成功')
            }).catch(() => {
                this.$message.info('已取消删除')
            })
        }
    }
}
</script>

<style lang="less" scoped>
@import '@/styles/minimal-gray-theme.less';

.bidder-child-page {
    .apply-minimal-gray-theme();
}

.page-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 20px;
}

.page-header-content {
    display: flex;
    flex-direction: column;
    text-align: start;
}

.header-action {
    text-align: end;
    flex-shrink: 0;
}

.page-subtitle {
    margin: 0;
    color: @gray-500;
    font-size: 14px;
    font-weight: 500;
    line-height: 1.6;
}

.page-title {
    color: @gray-700;
    margin: 0;
    font-size: 24px;
    font-weight: 600;
    line-height: 1.4;
}

.content-container {
    padding: 20px;
    border-radius: 8px;
    box-shadow: @shadow-sm;
    background: #fff;
    text-align: start;
    padding-bottom: 100px;
}

.info-card {
    background: @gray-50;
    border: 1px solid @gray-200;
    border-radius: 8px;
    margin-bottom: 24px;

    .card-header {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 18px 20px;
        border-bottom: 1px solid @gray-200;

        i {
            font-size: 18px;
            color: @gray-500;
        }

        .card-title {
            flex: 1;
            font-size: 18px;
            font-weight: 600;
            color: @gray-700;
            margin: 0;
        }

        .status-tag {
            font-weight: 500;
            // padding: 8px 16px;

            i {
                margin-right: 4px;
                font-size: 14px;
            }
        }
    }

    .card-body {
        padding: 20px;
    }
}

.info-item-row {
    margin-bottom: 16px;

    &:last-child {
        margin-bottom: 0;
    }

    .info-label {
        display: block;
        font-size: 13px;
        color: @gray-500;
        margin-bottom: 8px;
        font-weight: 500;
    }

    .info-value {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 14px;
        color: @gray-700;
        padding: 10px 12px;
        background: #fff;
        border: 1px solid @gray-200;
        border-radius: 6px;
        min-height: 40px;

        i {
            color: @gray-500;
            font-size: 16px;
        }

        &.file-name {
            font-weight: 500;
            color: @gray-700;
        }

        &.code {
            font-family: 'Courier New', monospace;
            background: @gray-100;
            color: @gray-700;
        }
    }
}

.info-row.spacing-top {
    margin-top: 20px;
}

// 上传容器
.upload-container {
    .upload-box {
        border: 2px dashed #d9d9d9;
        border-radius: 12px;
        padding: 40px;
        text-align: center;
        background: #fafafa;
        transition: all 0.3s ease;
        cursor: pointer;

        &:hover {
            border-color: #409eff;
            background: #f0f7ff;
        }

        &.uploaded {
            border-color: #67c23a;
            background: #f0f9ff;
            cursor: default;

            &:hover {
                border-color: #67c23a;
                background: #f0f9ff;
            }

            .upload-icon i {
                color: #67c23a;
            }
        }

        .upload-icon {
            margin-bottom: 16px;

            i {
                font-size: 64px;
                color: #409eff;
                transition: all 0.3s ease;
            }
        }

        .upload-text {
            margin-bottom: 24px;

            .upload-title {
                font-size: 16px;
                font-weight: 500;
                color: #303133;
                margin: 0 0 8px 0;
            }

            .upload-hint {
                font-size: 13px;
                color: #909399;
                margin: 0;
            }
        }

        .upload-btn {
            padding: 12px 32px;
            font-size: 14px;
        }
    }
}

// CA通知
.ca-notice {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    background: linear-gradient(135deg, #fff7e6 0%, #fffbf0 100%);
    border-left: 4px solid #fa8c16;
    border-radius: 8px;
    padding: 16px;
    margin-top: 20px;

    i {
        color: #fa8c16;
        font-size: 18px;
        margin-top: 2px;
        flex-shrink: 0;
    }

    span {
        color: #d46b08;
        font-size: 13px;
        line-height: 1.6;
    }
}

.info-notice {
    display: flex;
    align-items: center;
    gap: 12px;
    background: #fff;
    border: 1px solid @gray-200;
    border-left: 4px solid @gray-400;
    border-radius: 8px;
    padding: 12px 16px;
    margin-bottom: 20px;

    i {
        color: @gray-500;
        font-size: 18px;
        flex-shrink: 0;
    }

    span {
        color: @gray-600;
        font-size: 13px;
        line-height: 1.5;
    }
}

.form-field {
    margin-bottom: 20px;

    &:last-child {
        margin-bottom: 0;
    }

    .field-label {
        display: block;
        font-size: 14px;
        color: @gray-600;
        margin-bottom: 8px;
        font-weight: 500;

        &.required::before {
            content: '*';
            color: @error-color;
            margin-right: 4px;
        }
    }

    .el-input {
        width: 100%;
    }
}

/deep/ .el-input__inner {
    border-color: @gray-300;
    color: @gray-700;

    &:focus {
        border-color: @primary-color;
        box-shadow: 0 0 0 2px fade(@primary-color, 15%);
    }

    &::placeholder {
        color: @gray-400;
    }
}

.action-footer {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 16px;
    margin-top: 32px;
    padding: 24px;
    background: #fff;
    border: 1px solid @gray-200;
    border-radius: 8px;

    .el-button {
        min-width: 140px;
        padding: 14px 28px;
        font-size: 15px;
        font-weight: 600;
        border-radius: 4px;
    }
}

.upload-progress-content {
    padding: 20px;

    .upload-info {
        display: flex;
        align-items: center;
        gap: 12px;
        margin-bottom: 20px;
        padding: 16px;
        background: @gray-50;
        border: 1px solid @gray-200;
        border-radius: 8px;

        i {
            font-size: 32px;
            color: @gray-500;
        }

        span {
            font-size: 15px;
            color: @gray-700;
            font-weight: 500;
            flex: 1;
            word-break: break-all;
        }
    }

    .upload-status {
        text-align: center;
        font-size: 14px;
        font-weight: 500;
        margin-top: 16px;

        span {
            padding: 8px 16px;
            border-radius: 6px;
            display: inline-block;
            color: @gray-600;
        }
    }
}

.upload-icon {
    font-size: 24px !important;
    color: @primary-color !important;
    margin-right: 10px;
}


.upload-progress-bar {
    margin-top: 20px;
}

.status-success {
    color: @success-color !important;
}

.status-error {
    color: @error-color !important;
}

/deep/ .el-dialog {
    border-radius: 8px;
}

/deep/ .el-dialog__header {
    background: @gray-50;
    border-bottom: 1px solid @gray-200;
}

/deep/ .el-dialog__title {
    color: @gray-700;
    font-weight: 600;
}

@media (max-width: 768px) {
    .bidder-child-page {
        padding: 16px;
    }

    .page-header {
        flex-direction: column;
        align-items: stretch;
    }

    .header-action {
        text-align: left;
    }

    .page-title {
        font-size: 20px;
    }

    .content-container,
    .info-card .card-body,
    .info-card .card-header,
    .action-footer {
        padding-left: 16px;
        padding-right: 16px;
    }

    .info-card {
        .card-header {
            flex-wrap: wrap;
            gap: 8px;
        }
    }

    .action-footer {
        flex-direction: column;

        .el-button {
            width: 100%;
        }
    }
}
</style>
